import { ErrorPage } from '@/components/ErrorPage';
import AuthLayout from '@/pages/auth/layout';
import LoginPage from '@/pages/auth/login-page';

const LoginRoutes = {
  path: '/auth',
  element: <AuthLayout />,
  errorElement: <ErrorPage />,
  children: [
    {
      element: <LoginPage />,
      index: true,
    },
  ],
};

export default LoginRoutes;
